export default "https://cdn-static.gokick.com/assets/f56d8541e187cf36c438a68224daa166420c5eb6/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";